module.exports = __webpack_public_path__ + "static/media/right-arrow.4692082a.svg";